import { render, staticRenderFns } from "./CustomerMasterPage.vue?vue&type=template&id=51a392cc&scoped=true&"
import script from "./CustomerMasterPage.vue?vue&type=script&lang=js&"
export * from "./CustomerMasterPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerMasterPage.vue?vue&type=style&index=0&id=51a392cc&lang=scss&scoped=true&"
import style1 from "./CustomerMasterPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a392cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a392cc')) {
      api.createRecord('51a392cc', component.options)
    } else {
      api.reload('51a392cc', component.options)
    }
    module.hot.accept("./CustomerMasterPage.vue?vue&type=template&id=51a392cc&scoped=true&", function () {
      api.rerender('51a392cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/master/customerMaster/CustomerMasterPage.vue"
export default component.exports